module.exports = __webpack_public_path__ + "static/img/user-info-bg.94856d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user-info-bg.png
// module id = jR2i
// module chunks = 1